import type { ErrorObject } from 'ajv';
import type { TValidationDetail } from '#errors/errors.types.ts';
import type {
  TCompiledValidator,
  TPayloadLimits,
  TValidator,
} from './validation.types.ts';

export const limitKeywords = [
  'minLength',
  'maxLength',
  'minItems',
  'maxItems',
  'minimum',
  'maximum',
] as const;

const propertyParamByKeyword: Record<string, string> = {
  required: 'missingProperty',
  dependentRequired: 'missingProperty',
  additionalProperties: 'additionalProperty',
};

export const countCodePoints = (value: string): number => [...value].length;

const buildValidationDetail = ({
  instancePath,
  keyword,
  params,
  message,
}: ErrorObject): TValidationDetail => {
  const path = instancePath
    .slice(1)
    .replaceAll('/', '.')
    .replaceAll('~1', '/')
    .replaceAll('~0', '~');

  const property = params[propertyParamByKeyword[keyword]];
  const field =
    typeof property === 'string'
      ? [path, property].filter(Boolean).join('.')
      : path;

  return { code: keyword, field, message: message ?? keyword };
};

export const createValidator = <const TLimits extends TPayloadLimits>(
  compiled: TCompiledValidator,
  limits: TLimits,
): TValidator<TLimits> => {
  const validate = (value: unknown) => {
    if (compiled(value)) {
      return [];
    }

    return (compiled.errors ?? []).map(buildValidationDetail);
  };

  return Object.assign(validate, { limits });
};
